import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { Team } from "types";

@Component({
  selector: "app-roles-home-empty-state",
  templateUrl: "./roles-home-empty-state.component.html",
  styleUrls: ["./roles-home-empty-state.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RolesHomeEmptyStateComponent {
  @Input() public team: Team | null = null;
}
